import { css, keyframes } from 'styled-components';

export const animation = keyframes`
  0% {
    opacity: 0;
    transform: translateY(-100px);
  }

  100% {
    opacity: 1;
    transform: translateY(0);
  }
`;

export const animationFunction = css`
  animation-timing-function: cubic-bezier(0.175, 0.885, 0.32, 1.275);
`;

export const shake = keyframes`
  0% { transform: skewX(-15deg); }
  5% { transform: skewX(15deg); }
  10% { transform: skewX(-15deg); }
  15% { transform: skewX(15deg); }
  20% { transform: skewX(0deg); }
  100% { transform: skewX(0deg); }
`;
